@if (isLoading) {
  <span [ngClass]="{ 'spinner-border-sm': size === 'small' }" class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </span>
}
